import { useTranslation } from 'react-i18next';

import { Button, Typography } from '@cfa/react-components';

import { cn } from '@/utils/tailwind';

interface LoadMorePaginatorProps {
  className?: string;
  onClick: () => void;
  showing: number;
  showingText: string;
  total: number;
}

const LoadMorePaginator: React.FC<LoadMorePaginatorProps> = ({
  className,
  onClick,
  showing,
  showingText,
  total,
}) => {
  const { t } = useTranslation();
  const hasMore = showing < total;
  const hidden = total <= showing;

  return (
    <>
      {!hidden && (
        <div
          className={cn(
            'm-8 flex flex-col items-center justify-center gap-4',
            className,
          )}
          data-testid="LoadMorePaginator"
        >
          <Button color="secondary" disabled={!hasMore} onClick={onClick}>
            {t('Button.loadMore')}
          </Button>
          <Typography variant="body1">{showingText}</Typography>
        </div>
      )}
    </>
  );
};

export default LoadMorePaginator;
